import React, {Component} from 'react';
import './style.scss';
import Section from '../section';
import PropTypes from 'prop-types';
import {Player} from 'video-react';
import "video-react/dist/video-react.css";


class Part extends Component {


    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0,
            selectedSection: this.props.part ? this.props.part.sections[0] : null
        }
    }

    renderVideo(video) {
        return (
            <Player ref="player" fluid={true}>
                <source src={video}/>
            </Player>
        )
    }

    renderDescription(description) {
        if(description instanceof Object){
            return (
                <div>
                    <h5>
                        {description.header}
                    </h5>
                    {description.contents.map((item, index) => {
                        return <p key={index}>{item}</p>
                    })}
                </div>
            )
        }
        else{
            return (
                <div>
                    <p>{description}</p>
                </div>
            )
        }

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.part !== this.props.part) {
            this.setState({
                currentIndex: 0,
                selectedSection: this.props.part ? this.props.part.sections[0] : null
            });
            this.refs.player.load();

        }
    }


    renderSectionsSelector(sections) {
        return (
            <div className="section-select">
                <a onClick={() => handleSwitchOnChange(this, false)}><i className="fas fa-angle-double-left"></i></a>
                <select onChange={(event) => handleSelectOnChange(this, event)} value={this.state.currentIndex}>
                    {sections.map((section, index) => {
                        return <option key={index} value={index}>{section.label + "#" + (index + 1)}</option>
                    })}
                </select>
                <a onClick={() => handleSwitchOnChange(this, true)}><i className="fas fa-angle-double-right"></i></a>
            </div>);

        function handleSelectOnChange(self, event) {
            self.setState({
                currentIndex: parseInt(event.target.value),
                selectedSection: sections[event.target.value]
            });
        };

        function handleSwitchOnChange(self, isPlus) {
            let maxIndex = sections.length > 0 ? sections.length - 1 : 0;
            let currentIndex = self.state.currentIndex;
            let index = isPlus ? ((currentIndex === maxIndex) ? currentIndex : currentIndex + 1) : ((currentIndex === 0) ? 0 : currentIndex - 1);
            self.setState({
                currentIndex: index,
                selectedSection: sections[index]
            });

        };
    }

    render() {
        if (this.props.part) {
            let section = this.state.selectedSection || null;
            const {sections, video, description} = this.props.part;
            return (
                <div className="part">
                    {video && this.renderVideo(video)}
                    {description && this.renderDescription(description)}

                    <div className="part-section">
                        {sections && sections.length >= 2 && this.renderSectionsSelector(sections)}
                        {section && <Section section={section}/>}
                    </div>
                </div>
            );
        } else {
            return (
                <div>Empty</div>
            )
        }
    }
}


Part.propTypes = {
    part: PropTypes.object.isRequired,
};

export default Part;
